module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1012-0c491828659bc8b3dcd78c94f342c06b.png";